// SAT Human Development System™ · zentrale Marken- und Copy-Konfiguration.
// Trennung von Inhalt und Layout — spätere Mehrsprachigkeit (DE/EN/FR/IT) baut hier auf.

export const SAT_HDS = {
  brand: "SAT Human Development System™",
  claim: "Erkennen. Verstehen. Transformieren. Leben.",
  journey: "ASSESS → UNDERSTAND → REFLECT → TRANSFORM → MEASURE → EVOLVE",
  section: {
    kicker: "SAT SELF DISCOVERY",
    headline: "Du kannst nur verändern, was du erkennen kannst.",
    sub: "Zwei exklusive SAT Experiences machen sichtbar, wo du heute stehst, welche Ressourcen dich tragen und wo dein nächster Entwicklungsschritt liegen könnte.",
  },
  experiences: {
    circle: {
      key: "circle-of-life",
      trademark: "Circle of Life™",
      tagline: "Wie rund läuft dein Leben wirklich?",
      hero: "Die Landkarte deines heutigen Lebens.",
      intro:
        "Dein Leben besteht nicht aus einzelnen Problemen. Es ist ein System miteinander verbundener Lebensbereiche. Circle of Life hilft dir, dieses System sichtbar zu machen.",
      publicDescription:
        "Betrachte dein Leben aus einer neuen Perspektive. Circle of Life macht sichtbar, welche Lebensbereiche bereits tragen, wo Spannungsfelder bestehen und wo dein grösstes Transformationspotenzial liegen könnte.",
      cta: "CIRCLE OF LIFE ENTDECKEN",
      ctaSecondary: "MEINE EXPERIENCE ÖFFNEN",
      centralMessage: "Sieh dein Leben als Ganzes.",
      dimensions: [
        { key: "love", label: "Love & Partnership" },
        { key: "relationships", label: "Beziehungen" },
        { key: "family", label: "Familie" },
        { key: "body", label: "Körper & Gesundheit" },
        { key: "energy", label: "Energie" },
        { key: "self", label: "Selbst" },
        { key: "joy", label: "Lebensfreude" },
        { key: "career", label: "Beruf" },
        { key: "purpose", label: "Berufung" },
        { key: "money", label: "Wohlstand" },
        { key: "freedom", label: "Freiheit" },
        { key: "growth", label: "Entwicklung" },
      ],
    },
    survival: {
      key: "survival-of-the-fittest",
      trademark: "Survival of the Fittest™",
      tagline: "Wie gut bist du für dein Leben aufgestellt?",
      hero: "Die Architektur deiner Lebensfähigkeit.",
      intro:
        "Es geht nicht darum, stärker als andere zu sein. Es geht darum, in einer Welt voller Veränderung handlungsfähig, lernfähig und entwicklungsfähig zu bleiben.",
      publicDescription:
        "Veränderung verlangt mehr als Stärke. Sie verlangt Selbstführung, Anpassungsfähigkeit, emotionale Kompetenz, Energie und Orientierung.",
      cta: "SURVIVAL EXPERIENCE ENTDECKEN",
      ctaSecondary: "MEINE EXPERIENCE ÖFFNEN",
      centralMessage: "Das Leben verlangt nicht Perfektion. Es verlangt Entwicklung.",
      arc: "Survive → Adapt → Transform → Master",
      dimensions: [
        { key: "body", label: "Körper" },
        { key: "energy", label: "Energie" },
        { key: "mind", label: "Mentale Flexibilität" },
        { key: "emotion", label: "Emotion" },
        { key: "relationship", label: "Beziehung" },
        { key: "money", label: "Wirtschaftliche Kraft" },
        { key: "adaptability", label: "Anpassungsfähigkeit" },
        { key: "purpose", label: "Sinn" },
        { key: "selfleadership", label: "Selbstführung" },
      ],
    },
    lifemap: {
      key: "sat-life-map",
      trademark: "SAT Life Map™",
      hero: "Das Gesamtbild deiner persönlichen Entwicklung.",
      centralMessage: "Dein Leben hat ein Muster.",
      intro:
        "Die SAT Life Map verbindet deine äußere Lebensrealität mit deinen inneren Ressourcen und macht sichtbar, wo dein nächster Transformationshebel liegen könnte.",
    },
  },
  paths: {
    section: "/#self-discovery",
    circle: "/self-discovery/circle-of-life",
    survival: "/self-discovery/survival-of-the-fittest",
    lifemap: "/self-discovery/life-map",
  },
  // Access states — synchronized with backend enum
  accessStates: {
    LOCKED: "locked",
    REQUESTED: "requested",
    ACTIVE: "active",
    EXPIRED: "expired",
    SUSPENDED: "suspended",
  },
  // Session states
  sessionStates: {
    NOT_STARTED: "not_started",
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    INVALIDATED: "invalidated",
    ARCHIVED: "archived",
  },
};

export default SAT_HDS;
